import React, { useState } from 'react';
import '../styles/CommonComponentStyles.scss';
import { useNavigate } from 'react-router-dom';
import PrivacyEn from './core_content/PrivacyEn.js'; // English version
import PrivacyDe from './core_content/PrivacyDe.js'; // German version
import { Helmet } from 'react-helmet-async';

const PrivacyPolicy = () => {
    const navigate = useNavigate();
    const [isEnglish, setIsEnglish] = useState(true); // State to toggle between languages

    // Routes one level back to /account/help
    const handleBackRequest = () => {
        navigate("/");
    };

    const toggleLanguage = () => {
        setIsEnglish(!isEnglish); // Toggle the language state
    };

    return (
        <div className="common-styles">
            <Helmet>
                <title>generatebg - Privacy Policy</title>
                <meta name="description" content="Read generatebg privacy policy here." />
                <link rel="canonical" href={`${process.env.REACT_APP_CLIENT_URL}/privacy-policy`} />
            </Helmet>
            <button className="generic-account-button--center" onClick={handleBackRequest}>Go Back Home</button>
            <button className="generic-account-button--center" onClick={toggleLanguage}>
                {isEnglish ? 'Switch to German' : 'Auf Englisch wechseln'}
            </button>
            {isEnglish ? <PrivacyEn /> : <PrivacyDe />}
        </div>
    );
};

export default PrivacyPolicy;
